
import Vue from 'vue'

export default Vue.extend({
  name: 'ChefPricingList',
  props: {
    price: {
      type: Object,
      required: true
    }
  },
  data(): {
    showServiceCostPopup: boolean;
  } {
    return {
      showServiceCostPopup: false,
    }
  }
});
